// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QQbd","content":"styles_content__r0ghq"};